import { Formatters, Messages } from '../../codegen/Localize';

export function characterCounter(args: {value: string, maximum: number}): string {
  const overflow = args.value.length > args.maximum;

  if (overflow) {
    return Messages.metricsMetadataPanelDescriptionCharacterLimitExceeded({
      total: Formatters.formatCount(args.value.length),
      maximum: Formatters.formatCount(args.maximum)
    });
  }

  return Messages.metricsMetadataPanelDescriptionCharactersRemaining({
    characters: Formatters.formatCount(args.maximum - args.value.length)
  });
}
